import React from 'react';
import { motion } from 'framer-motion';
import { SPRING_CONFIG } from '../../utils/constants';

interface PremiumCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  glow?: boolean;
  padding?: string;
  blur?: boolean;
  onClick?: () => void;
}

const PremiumCard: React.FC<PremiumCardProps> = ({
  children,
  className = '',
  hover = false,
  glow = false,
  padding = 'p-6',
  blur = true,
  onClick
}) => {
  const baseClasses = `
    relative overflow-hidden rounded-2xl border border-white/10
    ${blur ? 'backdrop-blur-xl' : ''}
    bg-white/5
    ${glow ? 'shadow-2xl shadow-[#8AA5A2]/20' : 'shadow-xl'}
    ${hover ? 'hover:border-[#8AA5A2]/30 hover:shadow-[#8AA5A2]/30' : ''}
    ${onClick ? 'cursor-pointer' : ''}
    transition-all duration-300
    ${padding}
    ${className}
  `.trim();

  const MotionCard = motion.div;

  return (
    <MotionCard
      className={baseClasses}
      whileHover={hover ? { y: -2, scale: 1.01 } : {}}
      transition={SPRING_CONFIG}
      onClick={onClick}
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
      
      {/* Glow effect */}
      {glow && (
        <div className="absolute inset-0 bg-gradient-to-r from-[#8AA5A2]/10 to-[#6B9593]/10 opacity-50 pointer-events-none" />
      )}
    </MotionCard>
  );
};

export default PremiumCard;